/**
 * Возвращает код марки из хоста лендинга (ford, land_rover и т.д.) или null
 * @param {string} host
 * @returns {string|null}
 */
export function getLandingMarkFromHost(host) {
  if (!host || typeof host !== "string") return null;
  const firstPart = host.split(".")[0] || "";
  let markCode = firstPart.includes("farkop-")
    ? firstPart.split("-")[1]
    : firstPart;
  if (!markCode) return null;
  if (markCode === "landrover") markCode = "land_rover";
  if (markCode === "ssang_yong") markCode = "ssangyong";
  return markCode;
}

/**
 * Формирует текст логотипа лендинга из домена (farkop-ford.ru → "Farkop-Ford" и т.д.)
 * @param {string} host - хост, например "farkop-ford.ru" или "ford.farkop.ru"
 * @returns {string}
 */
export function getLandingLogoFromHost(host) {
  const markCode = getLandingMarkFromHost(host);
  if (!markCode) return "Farkop-Mark";

  const markName = markCode
    .split("_")
    .map((s) => s.charAt(0).toUpperCase() + s.slice(1).toLowerCase())
    .join("-");
  return `Farkop-${markName}`;
}
